export class AssignConfig {
    constructor() {
        this.operator = 'currentUser';
        this.multiSelect = true;
        this.necessary = false;
    }
    operator: string;
    multiSelect: boolean;
    necessary: boolean;
}
